<template>
<div>
    <!-- modal -->
    <b-modal id="invoiceHeaderFormModal" centered size="lg" no-close-on-backdrop ref="invoiceHeaderFormModal" :title=" $t('invoiceHeader.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-form>
                <b-row>
                    <b-col>
                        <validation-provider #default="{ errors }" :name=" $t('invoiceHeader.name')" rules="required">
                            <label for="invoice-header-name-input">{{ $t('invoiceHeader.name') }}</label>
                            <b-form-group>
                                <b-form-textarea id="invoice-header-name-input" v-model="name" size="sm" maxlength="300" rows="3" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <validation-provider :name="$t('invoiceHeader.jurisdiction')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <label for="invoice-header-jurisdiction-input">{{ $t('invoiceHeader.jurisdiction') }}</label>
                            <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="jurisdictionSelect" value-field="id" text-field="name" :options="jurisdictionOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getInvoiceHeaderList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            name: '',
            jurisdictionSelect: 0,
            jurisdictionOption: [],
        }
    },
    methods: {
        showInfo(id) {
            this.$refs['invoiceHeaderFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'InvoiceHeader'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.name = response.data.invoiceHeader.name
                    this.jurisdictionOption = response.data.jurisdictionList
                    this.jurisdictionOption.splice(0, 0, this.$nullSelected('name'))
                    if (response.data.invoiceHeader.jurisdictionId > 0) {
                        this.jurisdictionSelect = response.data.invoiceHeader.jurisdictionId;
                    }
                } else {
                    this.$bvModal.hide('invoiceHeaderFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                name: this.name,
                jurisdictionId: this.jurisdictionSelect 
            }
            const controller = {
                name: 'InvoiceHeader'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('invoiceHeaderFormModal')
                            this.getInvoiceHeaderList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
